export default __webpack_public_path__ + "static/media/edit-icon-disabled.2eaa1af3.svg";